<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" name="landing" size="large" color="#a4ce4d" type="timer" [fullScreen]="true"></ngx-spinner>
<div class="landing">
  <app-header *ngIf="location && !(location === '/coming-soon')"></app-header>
  <router-outlet></router-outlet>
  <app-footer *ngIf="location && !(location === '/coming-soon')"></app-footer>
</div>
